import { GTMolecularExportFn } from "../../components/GTMolecularExportFn";

const FN_NAME = "gtm-export-seq-selection";

const sunSatFilter = (d) => {
  const date = new Date(d);
  return ![0, 6].includes(date.getUTCDay());
};

function FnRun() {
  return <GTMolecularExportFn name={FN_NAME} disabledDate={sunSatFilter} />;
}

export { FnRun };
